import PassQr from './PassQr'

/**
 * The ZipPass itself — the hub's hero.
 *
 * Two honesty rules are encoded here:
 *   - The QR shown is the guest's STANDING pass payload, issued server-side and
 *     cached by the hub, so it renders offline. It is not a client-generated token.
 *   - `addToWalletUrl` currently points at an *unsigned* Google Wallet JWT —
 *     `packages/wallet-pass` returns a `...SIGNATURE` stub and never signs with Web
 *     Crypto. Linking that would be worse than not linking it, so the button
 *     renders as disabled until real RS256 signing ships. When the API starts
 *     returning a signed URL this component lights up with no other change.
 */
export default function PassCard(props: {
  passId: string | null
  addToWalletUrl: string | null
  qrPayload: string | null
}) {
  return (
    <section class="rounded-2xl bg-white/5 border border-white/10 p-5">
      <h2 class="text-sm font-semibold text-white/80 mb-3">Your ZipPass</h2>

      <PassQr qrPayload={props.qrPayload} />

      {props.addToWalletUrl ? (
        <a
          href={props.addToWalletUrl}
          target="_blank"
          rel="noopener noreferrer"
          class="mt-4 block w-full py-3 rounded-xl bg-white text-[#1a1a2e] font-semibold text-center
                 hover:bg-white/90 transition-colors"
        >
          Add to Google Wallet
        </a>
      ) : (
        <button
          type="button"
          disabled
          class="mt-4 w-full py-3 rounded-xl bg-white/5 text-white/40 font-medium cursor-not-allowed
                 border border-white/10"
        >
          Google Wallet — coming soon
        </button>
      )}

      {props.passId && <p class="mt-3 text-[10px] text-white/30 font-mono break-all">Pass ID: {props.passId}</p>}
    </section>
  )
}
